import { render, staticRenderFns } from "./ModalRiscos.vue?vue&type=template&id=3a4d5c3c&scoped=true"
import script from "./ModalRiscos.vue?vue&type=script&lang=js"
export * from "./ModalRiscos.vue?vue&type=script&lang=js"
import style0 from "./ModalRiscos.vue?vue&type=style&index=0&id=3a4d5c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d5c3c",
  null
  
)

export default component.exports